import { ChangeEvent, useState } from 'react';
import { Column } from '@tanstack/react-table';
import { getGroupedItems } from 'components/ListFilter/ListFilter.helpers';
import { useIntroducerContext } from 'contexts/IntroducerContext/IntroducerContext';
import { TApplication } from 'lendingApi/applications.types';
import {
  APPLICATION_STATUS_FILTERS,
  TERM_LENGTH_FILTERS,
} from 'utils/applications/applications.config';
import { COLUMN_IDS } from '../../Context/ApplicationsTableState.helpers';
import { useTrackFilter } from '../useTrackFilter.hook';

type TProps = {
  column: Column<TApplication, unknown>;
  onClose: () => void;
};

export const useSelectColumnFilter = ({ column, onClose }: TProps) => {
  const { splitTests } = useIntroducerContext();
  const { trackFilterApplied, trackFilterReset } = useTrackFilter(
    column.columnDef.header,
  );
  const initialFilterValue =
    (column.getFilterValue() as string[] | undefined) ?? [];

  const [selectedValues, setSelectedValues] = useState(initialFilterValue);

  const handleChange = ({
    target: { name },
  }: ChangeEvent<HTMLInputElement>) => {
    setSelectedValues((prev) =>
      prev.includes(name)
        ? prev.filter((val) => val !== name)
        : [...prev, name],
    );
  };
  const handleApply = () => {
    column.setFilterValue(selectedValues.length ? selectedValues : undefined);
    trackFilterApplied(selectedValues);
    onClose();
  };

  const handleReset = () => {
    setSelectedValues([]);
    column.setFilterValue(undefined);
    trackFilterReset();
  };

  const options =
    column.columnDef.id === COLUMN_IDS.status
      ? APPLICATION_STATUS_FILTERS()
      : TERM_LENGTH_FILTERS(splitTests?.hasAccessToPrimeLoans || false);

  return {
    groupedItems: getGroupedItems(options),
    selectedValues,
    handleChange,
    handleApply,
    handleReset,
  };
};
